import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';

import {
  EnumLangActions, LoadLangs, LoadLangsSuccess, LoadLangsFailure
} from './lang.actions';

import { LangService } from './lang.service';
import { map } from 'rxjs/operators';

@Injectable()
export class LangEffects {
  getLangs$ = createEffect(() => this.actions$.pipe(
    ofType<LoadLangs>(EnumLangActions.LoadLangs),
    switchMap((action) => {
      const regLocale = action.payload['locale'];
      return this.langService.loadLangs(action.payload).pipe(
        map((langs: {}) => new LoadLangsSuccess({ ...langs, reg_locale: regLocale })),
        catchError(({ error }) => of(new LoadLangsFailure(error))),
      );
    })
  ));

  constructor(
    private langService: LangService,
    private actions$: Actions
  ) { }
}
